export default {
  root: {
    overflow: 'hidden',
  }
};
